function shareRecommend() {
  return {
    recommendID: null,
    customerId: null,

    init() {
      this.$nextTick(() => {
        const inputEmail = document.querySelector('.share-recommendation__email-input input');
        const inputCheckbox = document.querySelector('.share-recommendation__email-checkbox input');

        const errorEmail = document.querySelector('.share-recommendation__error-input');
        const errorCheckbox = document.querySelector('.share-recommendation__error-checkbox');

        inputEmail?.addEventListener('input', () => {
          errorEmail?.classList.add('hidden');
          document.querySelector('.share-recommendation__sent-message')?.classList.add('hidden');
        });

        inputCheckbox?.addEventListener('change', () => {
          errorCheckbox?.classList.add('hidden');
          document.querySelector('.share-recommendation__sent-message')?.classList.add('hidden');
        });
      });
    },

    isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },
    showNotification({ message = '', status = 'ok' } = {}) {
      const sentMessage = document.querySelector('.share-recommendation__sent-message');

      if (!sentMessage) return;

      sentMessage.classList.remove('hidden');

      sentMessage.classList.remove('ok', 'success', 'error');

      sentMessage.classList.add(status);
      sentMessage.querySelector('span').innerText = message;
    },

    async submitSentRecommendations(patientName, recommendID, customerId, shareRecommendId, recommend_url) {
      const inputEmail = document.querySelector('.share-recommendation__email-input input');
      const inputCheckbox = document.querySelector('.share-recommendation__email-checkbox input');
      const emailSubmit = document.querySelector('.share-recommendation__email-submit.share-recommendation__box-submit');
      const sentSubmitMessage = document.querySelector('.share-recommendation__sent-message');

      const errorEmail = document.querySelector('.share-recommendation__error-input');
      const errorCheckbox = document.querySelector('.share-recommendation__error-checkbox');

      if (emailSubmit?.classList.contains('loading')) return;
      sentSubmitMessage?.classList.add('hidden');

      let isValid = true;

      errorEmail?.classList.add('hidden');
      errorCheckbox?.classList.add('hidden');

      const emailValue = inputEmail?.value?.trim();

      if (!emailValue || !this.isValidEmail(emailValue)) {
        errorEmail?.classList.remove('hidden');
        isValid = false;
      }

      if (!inputCheckbox?.checked) {
        errorCheckbox?.classList.remove('hidden');
        isValid = false;
      }

      if (!isValid) return;

      this.isAwaitingResponse = true;

      const cleanID = String(recommendID).split('/').pop();
      const url = `/apps/datajet/task/${shareRecommendId}`;

      // Get customer name from DOM first, then fallback to parameter, then extract from email
      let customerName = '';
      
      // Try to get from #recommendation-name input field
      const patientNameEl = document.querySelector('#recommendation-name');
      if (patientNameEl && patientNameEl.value?.trim()) {
        customerName = patientNameEl.value.trim();
      } 
      // Fallback to parameter (but check it's not an email)
      else if (patientName?.trim() && !patientName.includes('@')) {
        customerName = patientName.trim();
      } 
      // Last resort: extract from email (part before @)
      else {
        customerName = emailValue.split('@')[0];
      }

      const requestData = {
        store: true,
        share: {
          recommendation_id: `gid://shopify/Metaobject/${cleanID}`,
          practitioner_id: String(customerId),
          customer_email: emailValue,
          customer_name: customerName,
        }
      };

      emailSubmit.classList.add('loading');

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(requestData),
        });

        if (!response.ok) throw new Error('Request failed');

        const resData = await response.json();

        if (resData.status === 'success' && recommend_url) {
          setTimeout(() => {
            this.showNotification({
              message: resData.message || 'Recommendation sent',
              status: resData.status || 'success'
            });
            emailSubmit.classList.remove('loading');
            window.location.href = recommend_url;
          }, 5000);
        } else {
          emailSubmit.classList.remove('loading');
          this.showNotification({
            message: resData.message || 'Recommendation sent',
            status: resData.status || 'success'
          });
        }

      } catch (error) {
        console.error('[Share Recommend] Fetch error:', error);

        this.showNotification({
          message: resData.message || 'Something went wrong. Please try again.',
          status: resData.status || 'error'
        });

      } finally {
        this.isAwaitingResponse = false;
      }
    },
    async getVariantQtyInCart(variantId) {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      const item = cart.items.find(i => i.id === Number(variantId));
      return item ? item.quantity : 0;
    },

    async addSingleProducts(event, qty, variantId, note = '') {
      const button = event?.currentTarget;
      const containerSingleProduct = button.closest('.share-recommendation__products-details');
      if (button?.classList.contains('is-loading')) {
        return;
      }
      const errorBox = containerSingleProduct.querySelector('.share-recommendation__error-message.add-single');
      console.log('errorBox', errorBox);
      

      if (errorBox) {
        errorBox.innerHTML = '';
        errorBox.classList.add('hidden');
      }
      button?.classList.add('is-loading');
      try {
        qty = Number(qty);
        variantId = Number(variantId);
        if (!variantId || qty <= 0) return;

        /* =========================
          ADD TO CART
        ========================= */
        const body = JSON.stringify({
          items: [{
            id: variantId,
            quantity: qty,
            properties: { ...(note ? { Note: note } : {}), _bespokeid: 'hWN48B1i02xnfhhNVgxd9Y70?key=a8d46631d77ab200b94be6e19d14e70e' }
          }],
          sections: ['cart-icon-bubble', 'cart-drawer'],
          sections_url: '/'
        });

        const res = await fetch(routes.cart_add_url, {
          ...fetchConfig('javascript'),
          body
        });

        let state = await res.json();
        const stateNotification = state.description || state.message;

        /* =========================
          422 → FETCH REAL CART
        ========================= */
        if (res.status === 422) {
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();

          const sectionRes = await fetch(
            `/?sections=cart-icon-bubble,cart-drawer`
          );
          const sectionState = await sectionRes.json();

          state = {
            ...cart,
            sections: sectionState
          };

          // UX message
          if (stateNotification) {
            if (errorBox) {
              errorBox.innerHTML = stateNotification;
              errorBox.classList.remove('hidden');
            }
          }
          return;
        }

        /* =========================
          UPDATE SECTIONS
        ========================= */
        Object.entries(state.sections || {}).forEach(([id, html]) => {
          const el = document.getElementById(id);
          if (el) el.innerHTML = html;
        });

        /* =========================
          FIX DRAWER STATE
        ========================= */
        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
          drawer.querySelector('.drawer__inner-empty')?.remove();
          drawer.classList.remove('is-empty');
          drawer.setAttribute('aria-hidden', 'false');
          drawer.querySelector('.cart__ctas button')?.removeAttribute('disabled');
        }

        /* =========================
          OPEN DRAWER (SAFE)
        ========================= */
        requestAnimationFrame(() => {
          drawer?.open?.();
        });

        /* =========================
          PUBSUB (DAWN)
        ========================= */
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'share-recommendation',
          cartData: state
        });

      } catch (err) {
        console.error(err);
        if (errorBox) {
          errorBox.innerHTML = 'Une erreur est survenue lors de l’ajout des produits au panier.';
          errorBox.classList.remove('hidden');
        }
      }finally {
        button?.classList.remove('is-loading');
      }
    },

    async addAllProducts(event) {
      const button = event?.currentTarget;
      if (button?.classList.contains('is-loading')) return;

      const errorBox = document.querySelector('.share-recommendation__error-message.add-all');
      const errors = [];

      errorBox?.classList.add('hidden');
      errorBox.innerHTML = '';

      button.classList.add('is-loading');
      
      async function getVariantQtyInCart(variantId) {
        const res = await fetch('/cart.js');
        const cart = await res.json();

        const item = cart.items.find(i => i.id === variantId);
        return item ? item.quantity : 0;
      }


      try {
        const rows = [...document.querySelectorAll('.share-recommendation__products-details')];

        for (const row of rows) {
          const productTitle =
            row.dataset.productTitle ||
            row.querySelector('.product-title')?.textContent?.trim() ||
            'Ce produit';

          const variantId = Number(row.dataset.variantId);
          const qty = Number(row.dataset.productQty);
          const note = row.dataset.productNote || '';
          const maxQty = Number(row.dataset.maxQty);

          if (!variantId || qty <= 0) continue;

          const currentQty = await getVariantQtyInCart(variantId);

          if (maxQty && currentQty + qty > maxQty) {
            errors.push(`
              <strong>${productTitle}</strong> :
              Quantité maximale autorisée (${maxQty}) déjà atteinte.
            `);
            continue;
          }

          const body = JSON.stringify({
            items: [{
              id: variantId,
              quantity: qty,
              properties: { ...(note ? { Note: note } : {}), _bespokeid: 'hWN48B1i02xnfhhNVgxd9Y70?key=a8d46631d77ab200b94be6e19d14e70e' }
            }]
          });

          const res = await fetch(routes.cart_add_url, {
            ...fetchConfig('javascript'),
            body
          });

          const result = await res.json();

          if (!res.ok || result?.description || result?.message) {
            const shopifyMessage = result.description || result.message;
            if (shopifyMessage) {
              errors.push(`
                <strong>${productTitle}</strong> : ${shopifyMessage}
              `);
            }
          }
        }

        /* =========================
          FETCH REAL CART + SECTIONS
        ========================= */
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();

        const sectionRes = await fetch('/?sections=cart-icon-bubble,cart-drawer');
        const sections = await sectionRes.json();

        Object.entries(sections).forEach(([id, html]) => {
          document.getElementById(id)?.replaceChildren(
            document.createRange().createContextualFragment(html)
          );
        });

        /* =========================
          FIX DRAWER
        ========================= */
        const drawer = document.querySelector('cart-drawer');
        if (drawer && cart.item_count > 0) {
          drawer.querySelector('.drawer__inner-empty')?.remove();
          drawer.classList.remove('is-empty');
          drawer.setAttribute('aria-hidden', 'false');
          drawer.querySelector('.cart__ctas button')?.removeAttribute('disabled');
        }

        requestAnimationFrame(() => drawer?.open?.());

        /* =========================
          SHOW ALL MESSAGES (LIKE SINGLE)
        ========================= */
        if (errors.length && errorBox) {
          errorBox.innerHTML = `
            <ul>
              ${errors.map(msg => `<li>${msg}</li>`).join('')}
            </ul>
          `;
          errorBox.classList.remove('hidden');
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'share-recommendation-add-all',
          cartData: cart
        });

      } catch (err) {
        console.error(err);
        errorBox.textContent =
          'Une erreur est survenue lors de l’ajout des produits au panier.';
        errorBox.classList.remove('hidden');
      } finally {
        button.classList.remove('is-loading');
      }
    },

  }
}